var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 8a1 1 0 0 1-1 1h-4v14h4a1 1 0 1 1 0 2h-4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h4a1 1 0 0 1 1 1",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24 17.414a2 2 0 0 0 0-2.828l-2.293-2.293a1 1 0 0 0-1.414 1.414L21.586 15H13a1 1 0 1 0 0 2h8.586l-1.293 1.293a1 1 0 0 0 1.414 1.414z",
    clipRule: "evenodd"
  })));
};
export default SvgLogout;